var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChev = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 13 13"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#1916B0",
  d: "m12.103 4.552-6.052 6.05L0 4.553"
})));
export { SvgChev as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTMiIGhlaWdodD0iMTMiIHZpZXdCb3g9IjAgMCAxMyAxMyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEyLjEwMjUgNC41NTE1MUw2LjA1MTE1IDEwLjYwMjlMLTAuMDAwMjcwNDg5IDQuNTUxNDkiIHN0cm9rZT0iIzE5MTZCMCIvPgo8L3N2Zz4K";